<div class="language-switcher" role="group" aria-label="Idioma / Language / Idioma / Langue">
    <button *ngFor="let lang of languages" type="button" class="flag"
            [class.active]="current === lang.code"
            [attr.aria-current]="current === lang.code ? 'true' : null"
            [attr.aria-label]="lang.label" [title]="lang.label" [attr.lang]="lang.code"
            (click)="select(lang.code)">
        <svg viewBox="0 0 30 30" aria-hidden="true" [ngSwitch]="lang.code">
            <defs>
                <clipPath [attr.id]="clipId + '-' + lang.code"><circle cx="15" cy="15" r="15"></circle></clipPath>
            </defs>
            <g *ngSwitchCase="'es'" [attr.clip-path]="'url(#' + clipId + '-es)'">
                <rect width="30" height="30" fill="#C60B1E"></rect>
                <rect y="7.5" width="30" height="15" fill="#FFC400"></rect>
            </g>
            <g *ngSwitchCase="'en'" [attr.clip-path]="'url(#' + clipId + '-en)'">
                <g transform="translate(-15 0)">
                    <rect width="60" height="30" fill="#012169"></rect>
                    <path d="M0 0l60 30M60 0L0 30" stroke="#fff" stroke-width="6"></path>
                    <path d="M0 0l60 30M60 0L0 30" stroke="#C8102E" stroke-width="2.4"></path>
                    <path d="M30 0v30M0 15h60" stroke="#fff" stroke-width="10"></path>
                    <path d="M30 0v30M0 15h60" stroke="#C8102E" stroke-width="6"></path>
                </g>
            </g>
            <g *ngSwitchCase="'ca'" [attr.clip-path]="'url(#' + clipId + '-ca)'">
                <rect width="30" height="30" fill="#FCDD09"></rect>
                <rect y="3.33" width="30" height="3.33" fill="#DA121A"></rect>
                <rect y="10" width="30" height="3.33" fill="#DA121A"></rect>
                <rect y="16.67" width="30" height="3.33" fill="#DA121A"></rect>
                <rect y="23.34" width="30" height="3.33" fill="#DA121A"></rect>
            </g>
            <g *ngSwitchCase="'fr'" [attr.clip-path]="'url(#' + clipId + '-fr)'">
                <rect width="10" height="30" fill="#002395"></rect>
                <rect x="10" width="10" height="30" fill="#FFFFFF"></rect>
                <rect x="20" width="10" height="30" fill="#ED2939"></rect>
            </g>
        </svg>
    </button>
</div>
